import { useState } from "react";
import { faqs } from "@/mocks/dashan";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const toggle = (i: number) => setOpen((cur) => (cur === i ? null : i));

  return (
    <section id="faq" className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-[880px] mx-auto">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-question-answer-line"></i> 吃瓜问答
          </span>
          <h3 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            聊之前，你可能想问这些
          </h3>
          <p className="mt-3 text-foreground-600 leading-relaxed">
            我们把吃瓜群众问得最多的问题攒在一起，答案都来自实战复盘，不是空谈。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="rounded-2xl border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => toggle(i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-3 px-5 md:px-6 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-foreground-950 flex items-center gap-3">
                    <span className="shrink-0 w-7 h-7 rounded-full bg-accent-100 text-accent-700 text-xs flex items-center justify-center font-bold">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 pl-[64px] text-foreground-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}